(function () {
  function initShopAudio(root) {
    var button = root.querySelector('[data-llsh-shop-audio-button]');
    var audio = root.querySelector('[data-llsh-shop-audio]');
    var icon = root.querySelector('[data-llsh-shop-audio-icon]');
    var progress = root.querySelector('[data-llsh-shop-audio-progress]');

    if (!button || !audio || !icon || !progress) return;

    var playIcon = icon.innerHTML;
    var isSeeking = false;
    var pauseIcon = [
      '<svg class="llsh-shop-audio__svg llsh-shop-audio__svg--pause" viewBox="0 0 24 24" focusable="false" aria-hidden="true">',
      '<rect fill="currentColor" x="7.8" y="5.2" width="3.2" height="13.6" rx="0.2"></rect>',
      '<rect fill="currentColor" x="13" y="5.2" width="3.2" height="13.6" rx="0.2"></rect>',
      '</svg>'
    ].join('');

    function setProgress(value) {
      progress.value = value;
      progress.style.setProperty('--llsh-shop-audio-progress', value + '%');
    }

    function updateProgress() {
      if (isSeeking || !audio.duration) return;
      setProgress((audio.currentTime / audio.duration) * 100);
    }

    button.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      root.classList.add('is-audio-active');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', 'Pause 30-second shop guide');
      icon.innerHTML = pauseIcon;
    });

    audio.addEventListener('pause', function () {
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Play 30-second shop guide');
      icon.innerHTML = playIcon;
    });

    audio.addEventListener('ended', function () {
      audio.currentTime = 0;
      root.classList.remove('is-audio-active');
      setProgress(0);
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Play 30-second shop guide');
      icon.innerHTML = playIcon;
    });

    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', updateProgress);

    progress.addEventListener('input', function () {
      isSeeking = true;
      setProgress(progress.value);
      if (audio.duration) {
        audio.currentTime = (Number(progress.value) / 100) * audio.duration;
      }
    });

    progress.addEventListener('change', function () {
      isSeeking = false;
      updateProgress();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-llsh-shop-audio-root]').forEach(initShopAudio);
  });
})();

/* LOADLESS Shop: drag/swipe carousel, up to four images per product. */
(function () {
  function init() {
    document.querySelectorAll('[data-llsh-root] .llsh-card__media').forEach(function (media) {
      if (media.dataset.llshSwipeReady === 'true') return;
      var track = media.querySelector('[data-llsh-swipe-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.llsh-card__slide'));
      if (slides.length < 2) return;
      media.dataset.llshSwipeReady = 'true';
      var index = 0, startX = 0, startY = 0, deltaX = 0;
      var active = false, horizontal = false, suppressClickUntil = 0, mouseActive = false;
      media.querySelectorAll('img').forEach(function (img) { img.draggable = false; });

      function position(offset, animated) {
        track.classList.toggle('is-dragging', !animated);
        track.style.transform = 'translate3d(calc(' + (-index * 100) + '% + ' + offset + 'px), 0, 0)';
      }
      function begin(x, y) {
        active = true; horizontal = false; deltaX = 0;
        startX = x; startY = y;
      }
      function move(x, y) {
        if (!active) return false;
        var dx = x - startX, dy = y - startY;
        if (!horizontal && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy) * 1.15) horizontal = true;
        if (!horizontal) return false;
        deltaX = dx;
        var atEdge = (index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0);
        position(dx * (atEdge ? 0.22 : 1), false);
        return true;
      }
      function end(cancelled) {
        if (!active) return;
        if (horizontal) {
          suppressClickUntil = Date.now() + 800;
          if (!cancelled && Math.abs(deltaX) > Math.min(40, media.clientWidth * 0.15)) {
            index = Math.max(0, Math.min(slides.length - 1, index + (deltaX < 0 ? 1 : -1)));
          }
        }
        active = false; horizontal = false; deltaX = 0;
        position(0, true);
      }

      /* Native touch events work reliably inside clickable product links on iOS/Android. */
      media.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        begin(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      media.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        if (move(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
      }, { passive: false });
      media.addEventListener('touchend', function (e) {
        if (active && e.changedTouches.length) move(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        end(false);
      }, { passive: true });
      media.addEventListener('touchcancel', function () { end(true); }, { passive: true });

      /* Desktop: drag with mouse; keep tracking if cursor leaves the card. */
      media.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mouseActive = true;
        begin(e.clientX, e.clientY);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (mouseActive) move(e.clientX, e.clientY);
      });
      document.addEventListener('mouseup', function (e) {
        if (!mouseActive) return;
        move(e.clientX, e.clientY);
        mouseActive = false;
        end(false);
      });
      media.addEventListener('dragstart', function (e) { e.preventDefault(); });
      media.addEventListener('click', function (e) {
        if (Date.now() < suppressClickUntil) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
      window.addEventListener('resize', function () { position(0, true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
